var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"divider"},[_c('span',{style:({ padding: ("0 " + _vm.offset + "px") })},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }